import {Topic} from '../models/topics/topics.model';

export function splitTopics(topics: Topic[]): { topics: Topic[]; subjectAreas: Topic[] } {
  const tmpSubjectAreas: Topic[] = [];
  const tmpTopics: Topic[] = [];

  topics.forEach(topic => {
    if (topic.isSubjectArea) {
      tmpSubjectAreas.push(topic);
    } else {
      tmpTopics.push(topic);
    }
  });

  return { topics: tmpTopics, subjectAreas: tmpSubjectAreas };
}
